import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { func, shape } from "prop-types";
import { Field, Form, Formik } from "formik";
import * as i18nUtils from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { actions as comexActions } from "reducers/comex";

const FORM_ID = "comex.contact";

const DeleteContactForm = ({ handleClose, handleListReload, contactDestination }) => {
    const dispatch = useDispatch();
    const { fetchingDelete } = useSelector((state) => state.comex);

    const initialValues = {
        id: contactDestination?.idContactDestination || "",
        recipientName: contactDestination?.recipientName || "",
        country: contactDestination?.country || "",
        number: contactDestination?.number || "",
        currency: contactDestination?.currency || "",
    };

    useEffect(() => {
        if (!fetchingDelete) {
            handleListReload();
            handleClose();
        }
    }, [fetchingDelete]);

    const handleSubmit = (values) => {
        dispatch(comexActions.deleteComexContact({ idContactDestination: values.id }));
    };

    return (
        <div className="container centered">
            <h1 className="title-content form-drawer-title">
                <CustomText text={i18nUtils.get("comex.contact.delete.title")} />
            </h1>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                {() => (
                    <Form>
                        <div className="form-drawer-content">
                            <div className="pb-6" />
                            <I18n id="comex.contact.delete.subtitle" />
                            <div className="pb-6" />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="recipientName"
                                hidePlaceholder
                                disabled
                            />
                            <div className="pb-6" />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                labelText="comex.contact.swift-aba.label"
                                idForm={FORM_ID}
                                maxLength={50}
                                name="number"
                                hidePlaceholder
                                disabled
                            />
                            <div className="pb-6" />
                            <div className="pb-6" />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="country"
                                hidePlaceholder
                                disabled
                            />
                            <div className="pb-6" />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="currency"
                                hidePlaceholder
                                disabled
                            />
                            <div className="pb-6" />
                            <Button type="submit" bsStyle="primary" label="global.delete" loading={false} block />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

DeleteContactForm.propTypes = {
    handleClose: func.isRequired,
    contactDestination: shape({}).isRequired,
    handleListReload: func.isRequired,
};

DeleteContactForm.defaultProps = {};

export default DeleteContactForm;
